export default __webpack_public_path__ + "static/media/Intro to coding session.29a1ca1a.JPG";